import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage for web
import ReduxPersist from '../config/ReduxPersist';

// creates the store
export default (rootReducer: any, rootSaga: any) => {
  /* ------------- Redux Configuration ------------- */

  const middleware: any[] = [];
  const enhancers: any[] = [];

  /* ------------- Saga Middleware ------------- */

  const sagaMiddleware = createSagaMiddleware();
  middleware.push(sagaMiddleware);

  /* ------------- Assemble Middleware ------------- */

  enhancers.push(applyMiddleware(...middleware));

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers = 
    typeof window === 'object' && 
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? 
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : 
    compose;

  // Create store with initial state that ensures seamless-immutable compatibility
  const initialState = {};
  const store = createStore(rootReducer, initialState, composeEnhancers(...enhancers));

  // configure persistStore and check reducer version number
  let persistor: any = null;
  if (ReduxPersist.active) {
    const persistConfig = {
      ...ReduxPersist.storeConfig,
      storage, // Use localStorage instead of AsyncStorage
      // Add transforms to handle seamless-immutable properly
      transforms: [],
    };
    const persistedReducer = persistReducer(persistConfig, rootReducer as any);
    store.replaceReducer(persistedReducer as any);
    persistor = persistStore(store);
  }

  // kick off root saga
  let sagasManager = sagaMiddleware.run(rootSaga);

  return {
    store,
    sagasManager,
    sagaMiddleware,
    persistor
  };
};
